/**
 * LoadingScreen.constants.js
 *
 * Timing and copy for the post-Summary Loading Screen. Per the FSD:
 *  - Sequential progress messages synced to backend processing stages.
 *  - Estimated duration: 20-30 seconds.
 *  - If generation exceeds 45s, show a reassurance message instead of
 *    appearing frozen.
 *  - UC-02 Exception Flow: if generation exceeds 90s, offer a retry
 *    button.
 *
 * There's no real backend stage-sync channel wired up yet (no SSE/
 * websocket contract defined), so the progress bar and message cycling
 * here are simulated against a timer rather than driven by actual
 * server-reported stages — see the comment on SIMULATED_DURATION_MS in
 * LoadingScreen.js for how to swap in real stage events later.
 */

export const PROGRESS_MESSAGES = [
  "Analyzing your lifestyle…",
  "Calculating your nutrition targets…",
  "Preparing your personalized meal plan…",
];

// Midpoint of the FSD's "20-30 seconds" target — the simulated bar aims
// to reach TARGET_PROGRESS_CAP by this point, then holds there until the
// real generation call actually resolves.
export const SIMULATED_DURATION_MS = 25000;

// The bar never simulates its way to 100% on its own — it caps below full
// so the jump to 100% on a real success still reads as "finishing", not
// as a bar that lied about being done.
export const TARGET_PROGRESS_CAP = 92;

export const MESSAGE_INTERVAL_MS = Math.round(SIMULATED_DURATION_MS / PROGRESS_MESSAGES.length);

// How often the simulated progress bar advances.
export const PROGRESS_TICK_MS = 200;

export const REASSURANCE_THRESHOLD_MS = 45000;
export const REASSURANCE_MESSAGE = "Still working on your plan…";

export const RETRY_OFFER_THRESHOLD_MS = 90000;
export const RETRY_OFFER_MESSAGE = "This is taking longer than expected.";

export const ERROR_MESSAGE = "Something went wrong while generating your plan.";
